import React from 'react';
import { ServiceTemplate } from '../ServiceTemplate';
import { trademarkSearchData } from '../../servicesData';

export const TrademarkSearch = ({ onOpenPopup }) => {
  return (
    <ServiceTemplate
      service={trademarkSearchData}
      onOpenPopup={onOpenPopup}
      showPricing={false}
    />
  );
};